import React from 'react';
import Icon from '../../../components/AppIcon';

const WhatYouGetSection = () => {
  const features = [
    {
      id: 1,
      icon: "Cloud",
      title: "Deploy Anywhere",
      description: "Cloud, edge, or on-premises—Sleeve deploys agents across your entire infrastructure with consistent orchestration"
    },
    {
      id: 2,
      icon: "Network",
      title: "Coordinate at Scale",
      description: "Orchestrate thousands of autonomous agents, legacy systems, and human operators as unified workflows"
    },
    {
      id: 3,
      icon: "Shield",
      title: "Maintain Control",
      description: "Human-in-the-loop oversight with approval gates, escalation policies, and real-time operational visibility"
    }
  ];

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8 bg-card/30">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-2xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            What You Get with Sleeve
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Enterprise-grade orchestration infrastructure that unifies agents, systems, and people
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {features?.map((feature) => (
            <div
              key={feature?.id}
              className="bg-card border border-border rounded-lg p-6 md:p-7 lg:p-8 hover:border-primary/50 transition-all duration-300"
            >
              <div className="flex flex-col items-start gap-4">
                {/* Icon */}
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
                </div>

                {/* Text Content */}
                <div className="flex flex-col gap-2">
                  {/* Title */}
                  <h3 className="text-lg md:text-xl font-semibold text-foreground">
                    {feature?.title}
                  </h3>

                  {/* Description */}
                  <p className="text-xs md:text-sm lg:text-base text-muted-foreground leading-relaxed">
                    {feature?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatYouGetSection;